module.exports = __webpack_public_path__ + "static/media/etron.391eec4d.pdf";